import custom from './custom';
import promoteJob from './promoteJob';
import scheduleJobs from './scheduleJobs';
import promoteJobs from './promoteJobs';
import promoteContent from './promoteContent';
import promoteContentShares from './promoteContentShares';
import scheduleContentShares from './scheduleContentShares';
import invite from './invite';
import leaderboardIndividual from './leaderboardIndividual';
import leaderboardOverall from './leaderboardOverall';
import collectiveGoal from './collectiveGoal';
import gamificationUpdateIndividual from './gamificationUpdateIndividual';

export default [
  custom,
  invite,
  promoteJob,
  promoteJobs,
  scheduleJobs,
  promoteContent,
  promoteContentShares,
  scheduleContentShares,
  leaderboardIndividual,
  leaderboardOverall,
  collectiveGoal,
  gamificationUpdateIndividual
];


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/teams/index.js